export default __webpack_public_path__ + "static/media/AE.d2f94d44.svg";